module.exports = __webpack_public_path__ + "img/s4.4aff09c6.jpg";